import React, {Component} from 'react'

class NotFound extends Component {
  render() {
    return (
      <div className="not-found">
        <h1>404</h1>
        <h3>Page not found</h3>
      </div>
    )
  }
}

export default NotFound
